export interface GooglePrediction {
  place_id: string;
  reference: string;
  description: string;
  matched_substrings: { length: number; offset: number }[];
  structured_formatting: {
    main_text: string;
    main_text_matched_substrings: { length: number; offset: number }[];
    secondary_text: string;
    secondary_text_matched_substrings: { length: number; offset: number }[];
    terms: { value: string; offset: number }[];
  };
  types: string[];
}
